<ng-container *transloco="let t">
  @for (module of modules(); track module.moduleId) {
    @if (module.isTriggered) {
      <pxc-callout
        containerClass="before:text-text-brand-tertiary!"
        [appearance]="'neutral'"
        [description]="t('Les champs ont été complétés avec les données associées.')"
        [icon]="$safeNavigationMigration(module.display?.action?.icon) | formIcon">
        <button
          appearance="outline"
          data-testid="trigger-success"
          iconStart="@tui.rotate-ccw"
          tuiButton
          type="button"
          [size]="'s'"
          (click)="resetModule(module)">
          {{ t('Réinitialiser') }}
        </button>
      </pxc-callout>
    } @else {
      @if (module.display?.description) {
        <pxc-callout
          containerClass="bg-background-brand-secondary!"
          [description]="module.display.description"
          [hint]="module.display.hint"
          [icon]="$safeNavigationMigration(module.display?.action?.icon) | formIcon">
          <ng-container *ngTemplateOutlet="triggerButton" />
        </pxc-callout>
      } @else {
        <ng-container *ngTemplateOutlet="triggerButton" />
      }

      <ng-template #triggerButton>
        <button
          appearance="form-trigger"
          tuiButton
          type="button"
          [iconStart]="$safeNavigationMigration(module.display?.action?.icon) | formIcon"
          (click)="triggerModule(module)">
          {{ module.display?.action?.label }}
        </button>
      </ng-template>
    }
  }
</ng-container>
